import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import PostGrid from '../Grid/PostGrid';
import PostsTable from './PostsTable/PostsTable';

const Posts = () => {
  const renderTable = useMediaQuery('(min-width: 1200px)');
  if (renderTable) return <PostsTable />;
  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      className="pt-1 pb-3"
    >
      <PostGrid
        active="dashboard"
        usePrivatePosts
        query={{ limit: 10 }}
        grid={{ lg: 8, md: 10, sm: 11, xs: 12 }}
        cardHeight={140}
        poststyle="list"
        warnWhenHidden
      />
    </Grid>
  );
};

export default Posts;
